/**
 * @file: ApiKeyPage.js
 */
import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async'
import { injectIntl } from 'react-intl'
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom'
import NavigationBar from '../partials/NavigationBar'
import Footer from '../partials/Footer'
import withAppStore from '../../util/withAppStore'

import AppStore from '../../stores/AppStore'
import AppDispatcher from '../../dispatchers/AppDispatcher'

import styles from '../../../css/devicePage.module.css'
import ApiKeyModule from '../partials/SupportPageComponents/ApiKey'

const getApiKeys = (customerID) => {
  AppDispatcher.dispatch({
    action: 'get-customer-api-keys',
    customerID,
  })
}

function ApiKeyPage (props) {
  const navigate = useNavigate()
  const { customerID } = useParams()
  const location = useLocation()

  const [once, setOnce] = React.useState(false)

  const goBack = React.useCallback(() => {
    navigate('/support')
  }, [navigate])

  const handleChange = React.useCallback(() => {
    // forceUpdate equivalent - component will re-render when AppStore changes
  }, [])

  React.useEffect(() => {
    window.scrollTo(0, 0) // start at top
    AppStore.addChangeListener(handleChange)
    getApiKeys(customerID)

    return () => {
      AppStore.removeChangeListener(handleChange)
    }
  }, [handleChange, customerID])

  React.useEffect(() => {
    const {
      data: {
        customerApiKeys: {
          data: apiKeys,
        }
        = [],
      },
    } = AppStore
    if (once === false && customerID && apiKeys.length < 1) {
      setOnce(true)
      getApiKeys(customerID)
    }
  }, [once, customerID])

  const {
    auth: { logout: logoutFn },
    intl: { formatMessage },
    route: { path: page },
  } = props

  const {
    data: {
      user: {
        permissions: currentPermission,
      },
      customerApiKeys: {
        data,
      } = {},
    },
  } = AppStore

  const logout = () => logoutFn(navigate)

  if (currentPermission.level < 20) {
    navigate('/support')
  }

  const CREATE_API = formatMessage({
    id: 'support.api.createAPI',
    defaultMessage: 'Create Altrac API Key',
    description: 'Create Altrac API Key label',
  })
  let createButtonStyles = `${styles.settingButtonCustomer} ${styles.settingButtonCustomerAPI}`
  let isValid = true
  if (data.count >= 3) {
    createButtonStyles = `${styles.settingButtonCustomer} ${styles.settingButtonCustomerDisabled} ${styles.settingButtonCustomerAPI}`
    isValid = false
  }

  const navButton = (subPage, label) => (
    <div key={label} style={{ display: 'inline-block' }}>
      <Link
        to={isValid ? `${subPage.match(/^[a-z]{1,25}/i) ? `/support/${customerID}/${subPage}` : subPage}` : ''}
        className={createButtonStyles}
      >
        <div className={`${styles.settingName} ${styles.settingNameCenter}`}>
          <h3>
            <i className='fa fa-plus' style={{ marginRight: '1em', fontSize: '20px' }} />
            {' '}
            {label}
          </h3>
        </div>
      </Link>
    </div>
  )

  const navButtons = []

  if (currentPermission.level >= 20) {
    navButtons.push(navButton('createAPI', CREATE_API))
  }

  const ApiKey = formatMessage({ id: 'support.api.keys', defaultMessage: 'Altrac API Keys' })

  return (
    <div>
      <Helmet><title>{ApiKey}</title></Helmet>
      <NavigationBar
        backFunc={goBack}
        name={ApiKey}
        page={page}
        logOut={logout}
      />

      <div className={styles.pageWidth}>
        <div>
          {navButtons}
        </div>
        <div>
          <ApiKeyModule
            user={AppStore.getUser()}
            customerApiKeys={data}
            getData={getApiKeys}
            customerID={customerID}
            formatMessage={formatMessage}
          />
        </div>
        <div className={styles.endSpace} />
      </div>
      <Footer />
    </div>
  )
}

ApiKeyPage.propTypes = {
  auth: PropTypes.object,
  intl: PropTypes.object,
  route: PropTypes.object,
}

export default withAppStore(injectIntl(ApiKeyPage))
